import { Injectable } from '@angular/core';
import { ShowHighlightService } from './show-highlight.service';

@Injectable({ providedIn: 'root' })
export class ShowHighlightNgService extends ShowHighlightService {}
